import { ADD_LOGIN_DETAILS } from './constants';
import {  AddLoginDetailsAction } from './types';


export const addLoginDetails = (payload: AddLoginDetailsAction['payload']): AddLoginDetailsAction => ({
  type: ADD_LOGIN_DETAILS,
  payload,
});
